import { SupervisorType } from "../action-types";

export const setSettings = (title: string) => {
    return {
        type: SupervisorType.SET_SETTINGS,
        payload: title
    }
}